
// 登录相关接口
import request from '@/utils/request'

// 发送邮箱验证吗方法
export const sendCode =(email)=>{
    return request.get(
        '/sendEmail',
        {
            params:{
                email:email
            }
        }
    )
}

// 发送注册信息方法
export const register=(registerUserRequest)=>{
    return request.post(
        '/register',
        registerUserRequest
    )
}


// 发送登录方法
export const login=(loginUserRequest)=>{
    return request.post(
        '/login',
        loginUserRequest
    )
}
